import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-ribyte-50 pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-ribyte-200 rounded-full blur-3xl opacity-50"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-ribyte-300 rounded-full blur-3xl opacity-40"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-ribyte-900 tracking-tight mb-6">
          Soluciones Integrales<br className="hidden md:block" /> para su Empresa
        </h1>
        <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-600 mb-10 leading-relaxed">
          Impulse su negocio con tecnología de vanguardia. Descubra <span className="font-semibold text-ribyte-600">RYO</span>, nuestro CRM todo en uno diseñado para potenciar su crecimiento.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button className="bg-ribyte-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-ribyte-700 transition-all shadow-lg hover:shadow-ribyte-500/30 flex items-center justify-center gap-2">
            Descubrir RYO CRM
            <ArrowRight size={20} />
          </button>
          <button className="bg-white text-ribyte-700 border border-ribyte-200 px-8 py-4 rounded-xl font-bold text-lg hover:bg-ribyte-50 transition-all shadow-sm hover:border-ribyte-300">
            Agendar Demo
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
